import Lenis from 'lenis'
import initReveal from './reveal.js'
import initWordReveal from './word-reveal.js'
import Header from '../../blocks/header/scripts.js'
import Hero from '../../blocks/hero/scripts.js'
import Button from "../../blocks/button/scripts"
import SliderImg from '../../blocks/slider-img/scripts'
import SliderDouble from "../../blocks/slider-double/scripts"
import PictoList from "../../blocks/picto-list/scripts"
import SliderTestimaonials from '../../blocks/testimonials/scripts.js'
import SliderWeeks from '../../blocks/slider-weeks/scripts.js'
import Faq from '../../blocks/faq/scripts.js'
import SliderChambres from '../../blocks/slider-chambres/scripts.js'
import Blog from '../../blocks/blog/scripts.js'
import Contact from '../../blocks/contact/scripts.js'
import Map from '../../blocks/map/scripts.js'
import ImgLink from '../../blocks/img-link/scripts.js'
import ArticleBlog from '../../blocks/article-blog/scripts.js'
import TripleImage from '../../blocks/triple-image/scripts.js'
import Footer from '../../blocks/footer/scripts.js'


document.addEventListener('DOMContentLoaded', () => {

  const header = document.querySelector('.header')
  if (header) new Header(header)

  document.querySelectorAll('.hero').forEach(el => new Hero(el));
  // SLIDER DOUBLE
  document.querySelectorAll('.slider-double').forEach(el => new SliderDouble(el));
  document.querySelectorAll('.picto-list').forEach(el => new PictoList(el));
  document.querySelectorAll('.triple-image').forEach(el => new TripleImage(el));
  document.querySelectorAll('.testimonials').forEach(el => new SliderTestimaonials(el));
  document.querySelectorAll('.slider-weeks').forEach(el => new SliderWeeks(el));

  document.querySelectorAll('.slider-img').forEach(el => new SliderImg(el))
  document.querySelectorAll('.faq').forEach(el => new Faq(el))
  document.querySelectorAll('.slider-chambres').forEach(el => new SliderChambres(el))
  document.querySelectorAll('.blog--inner').forEach(el => new Blog(el))
  document.querySelectorAll('.contact').forEach(el => new Contact(el))
  document.querySelectorAll('.map').forEach(el => new Map(el))
  document.querySelectorAll('.img-link').forEach(el => new ImgLink(el))
  document.querySelectorAll('.article-blog').forEach(el => new ArticleBlog(el))
  document.querySelectorAll('.footer').forEach(el => new Footer(el))

  // Initialisé en dernier pour capturer les slides clonés par Swiper (loop mode)
  document.querySelectorAll('.btn').forEach(el => new Button(el))

  initReveal()
  initWordReveal()

  new Lenis({
    autoRaf: true,
    lerp: 0.1,
    wheelMultiplier: 0.85
  })

})
